<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    鲤鱼门站<br>
站点介绍<br>
鲤鱼门站位于向西延伸的桃园路中线方向（规划桃园路立交桥）北侧及平南铁路西侧，鲤鱼门海车辆段、龙海家园等，平南铁路西侧为规划填海用地,基本建筑完成,现为空地;紧靠平南铁路东侧雨水渠为嘉进隆汽车综合广场。该站为地下站.<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:03	23:24	1号线	2分钟	4分40秒<br>
机场东	06:10	23:44	1号线	2分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:15	23:23	1号线	3分45秒	5分45秒<br>
机场东	06:34	23:43	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:15	00:23	1号线	3分45秒	5分45秒<br>
机场东	06:34	00:43	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
桂湾四路、十一号路（西）、梦海大道（东）、龙海家园、深圳地铁前海车辆段、前海深港基象前海<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 鲤鱼门地铁站<br>
M418<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>

